import { Component, OnInit, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { InventoryService } from '../../services/inventory.service';
import { PurchasingService } from '../../services/purchasing.service';
import { OrdersService } from '../../services/orders.service';
import { OmsService } from '../../services/oms.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Location } from '@angular/common'
import { PrintService } from '../../services/print.service'
import { UsersService } from 'app/services/users.service';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, Subject, of } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';

@Component({
	selector: 'app-warehouse-stock-counts',
	templateUrl: './warehouse-stock-counts.component.html',
	styleUrls: ['./warehouse-stock-counts.component.scss'],
	animations: [
		trigger('flipState', [
			  state('active', style({
				  transform: 'rotate3d(0, 1, 0, 179deg)',
			  })),
			  state('inactive', style({
				  transform: 'rotateY(0)'
			  })),
			  state('orderlookup', style({
				  transform: 'rotateY(179deg)'
			  })),
			  transition('active => inactive', animate('500ms ease-out')),
			  transition('inactive => active', animate('500ms ease-in')),
			  transition('inactive => orderlookup', animate('500ms ease-out')),
			  transition('orderlookup => inactive', animate('500ms ease-in')),
		  ]),
		trigger('slideInOut', [
			state('in', style({
				height: '*',
				opacity: 1,
				overflow: 'hidden'
			})),
			state('out', style({
				height: '0px',
				opacity: 0,
				overflow: 'hidden'
			})),
			transition('in => out', animate('300ms ease-in-out')),
			transition('out => in', animate('300ms ease-in-out'))
		])
	]
})
export class WarehouseStockCountsComponent implements OnInit, OnDestroy {
	today = new Date();
	@ViewChild('count_table') printtable: ElementRef;
	color: any = 'blue';

	location: any = '';
	locations: any = [];
	suppliers: any = false;
	user: any = [];

	sheetForm: FormGroup;
	vendor_selected: any = false;
	sending = false;
	exporting = false;
	// counting_items: any =false;
	fetching = false;
	nil = new FormControl(false);
	flip = 'inactive';
	filename = 'StockCounts';
	stockCountsLink: any = false;
	config: any = false;

	isPosUser: any = false;
	savingCounts: any = false;
	autoSaving = false;
	lastAutoSaveSuccess = false;
	filtersExpanded = true;
	counting_items: MatTableDataSource<any> | false = false;
	allItems: any[] = []; // Store all items for filtering
	@ViewChild('reviewComponent') reviewComponent: any;
	@ViewChild('paginatorBottom', { static: true }) paginator!: MatPaginator;
	dataObs: Observable < any > ;
	items_per_page = [50,100,250,500];
	pagesizedefault = 100;

	limit_load: any = false;
	private autoSaveSubject = new Subject<void>();
	private autoSaveSubscription: any;

	@ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
		this.paginator = mp;
		this.setDataSourceAttributes();
	}

	setDataSourceAttributes() {
		if (this.counting_items && this.paginator) {
			this.counting_items.paginator = this.paginator;
		}
	}

	constructor(private cd: ChangeDetectorRef, private usersService: UsersService, public printService: PrintService, public lLoaction: Location, private fb: FormBuilder,private route: ActivatedRoute, public router: Router, private modalService: NgbModal, private omsService: OmsService, private globalSearchService: GlobalSearchService, private inventoryService: InventoryService, public ordersService: OrdersService, public purchasingService: PurchasingService) {

		this.color = this.globalSearchService.getColor();

		this.usersService.isPosUser().subscribe((isPOS: any) => {
			this.isPosUser = isPOS;
			this.limit_load = true;
			isPOS ? this.limitLocations() : ''
		})

		this.globalSearchService.user.subscribe((u: any) => {
			this.user = u;
			this.location = u.user.defaultlocation.loccode
		});
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config =  r;
		})
	
	}

	ngOnInit(): void {
		// Initialize form immediately so it's always available
		if(!this.sheetForm) {
			this.initializeForm();
		}

		// Setup auto-save with debounce and switchMap to prevent race conditions
		// switchMap cancels previous requests if a new one comes in
		this.autoSaveSubscription = this.autoSaveSubject.pipe(
			debounceTime(1000),
			switchMap(() => {
				// Return observable from autoSave, or empty if no items
				if(!this.allItems || !this.allItems.length) {
					return of(null);
				}
				const itemsToSave = this.buildItemsToSave();
				if(itemsToSave.length === 0) {
					return of(null);
				}
				this.autoSaving = true;
				this.lastAutoSaveSuccess = false;
				return this.inventoryService.saveCounts(itemsToSave).pipe(
					map(r => ({ success: r.success })),
					catchError(() => of({ success: false }))
				);
			})
		).subscribe(result => {
			this.autoSaving = false;
			if(result && result.success) {
				this.lastAutoSaveSuccess = true;
				setTimeout(() => {
					this.lastAutoSaveSuccess = false;
				}, 3000);
			} else {
				this.lastAutoSaveSuccess = false;
			}
		});

		this.globalSearchService.locations.subscribe(async (results: any) => {
			this.locations = results || [];
			if(results && results.length){
				// Update form with first location if not set
				if(this.sheetForm && (!this.sheetForm.get('location').value || this.sheetForm.get('location').value === '')) {
					this.sheetForm.get('location').setValue(this.locations[0].loccode);
				}
				this.limitLocations();
			}
		});

		this.purchasingService.getSuppliers('').subscribe(async (results: any) => {
			this.suppliers = results || [];
			if(!this.limit_load){
				this.initialLoad();
			}
		})

	}

	ngOnDestroy(): void {
		if(this.autoSaveSubscription) {
			this.autoSaveSubscription.unsubscribe();
		}
		if(this.savingCounts) {
			this.savingCounts.unsubscribe();
		}
	}

	initializeForm(){
		const defaultLocation = (this.locations && this.locations.length > 0) ? this.locations[0].loccode : '';
		this.sheetForm = this.fb.group({
			keywords: [''],
			location: [defaultLocation, Validators.required],
			vendor: [this.vendor_selected],
			category: [''],
			lineid: [''],
			stockid: [''],
		});
	}

	initialLoad(){
		if(!this.sheetForm) {
			this.initializeForm();
		}
		
		if(this.locations && this.locations.length > 0) {
			const currentLocation = this.sheetForm.get('location').value;
			if(!currentLocation || currentLocation === '') {
				this.sheetForm.get('location').setValue(this.locations[0].loccode);
			}
		}

		// Only fetch counts if we have a location selected
		const locationValue = this.sheetForm.get('location').value;
		if(locationValue) {
			this.fetching = true;
			this.inventoryService.getCurrentCounts(this.sheetForm.value).subscribe(r  => {
				this.fetching = false;
				if(r.success && r.items && r.items.length > 0) {
					this.setPagination(r.items)
				}
				// No existing counts - this is normal on first entry, don't show error
				// User can click "Create / Load Sheets" to start counting
			}, error => {
				this.fetching = false;
				// Don't show error on initial load - it's expected if no counts exist yet
			})
		}
	}

	limitLocations(){
		if(this.isPosUser && this.locations && this.locations.length){
			this.locations = this.locations.filter((loc) => loc.loccode == this.user.user.defaultlocation.loccode)
			this.initialLoad();
		} else if(!this.sheetForm) {
			// If not POS user or locations filtered, still initialize form
			this.initialLoad();
		}
	}


	resetSheets(event?: any) {
		// Return to main "Create / Load Sheets" view without auto-reloading data
		// Backend clear has already removed frozen sheets and counts; user can explicitly re-load.
		this.counting_items = false;
		this.fetching = false;
		this.flip = 'inactive';
		// Expand filters so user can immediately run Create/Load again
		this.filtersExpanded = true;
		// Clear local data so we don't show stale rows
		this.allItems = [];
		this.dataObs = null as any;
		
		// If review component exists and has count results, clear those too
		if(this.reviewComponent) {
			this.reviewComponent.items = false;
			this.reviewComponent.allItems = false;
			this.reviewComponent.filteredItems = false;
			this.reviewComponent.count_results = false;
			this.reviewComponent.transno = '';
			this.reviewComponent.filename = 'StockCounts';
		}
		
		// Force change detection to update the view
		this.cd.detectChanges();
	}

	pdfLink() {
		return this.inventoryService.printCountSheets(this.sheetForm.value)
	}

	exportXls() {
		this.exporting = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const data = {
			content: encoded,
			filename: this.filename,
		}

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.exporting = false;
		});
	}

	keywordItemSearch() {
		// Trigger search when item field search button is clicked
		if(this.sheetForm && this.sheetForm.get('stockid').value) {
			this.createLoadSheets();
		}
	}

	keywordSearch() {
		// Trigger search when bin/keywords field search button is clicked
		if(this.sheetForm && this.sheetForm.get('keywords').value) {
			this.createLoadSheets();
		}
	}

	selectVendor(supplier: any) {
		const supp = supplier == '' ? '' : supplier.supplierid;
		this.vendor_selected = supp;
		this.sheetForm.get('vendor').setValue(supp);
	}

	selectCategory(value: any) {
		const cat = value == '' ? '' : value.categoryid;
		this.sheetForm.get('category').setValue(cat);
	}

	selectProductLine(value: any) {
		const line = value == '' ? '' : value.line_field;
		this.sheetForm.get('lineid').setValue(line);
	}

	createLoadSheets() {
		this.fetching = true;
		
		const data = this.sheetForm.value;
		data.user = this.user.user.userid;
		data.ispos = this.isPosUser;

		// First try to load existing counts, if none exist, create new sheets
		this.inventoryService.getCurrentCounts(data).subscribe( (r:any) => {
			if(r.success && r.items && r.items.length > 0) {
				// Load existing counts
				this.fetching = false;
				this.setPagination(r.items);
			} else {
				// No existing counts, create new sheets
				this.inventoryService.createLoadSheets(data).subscribe( (createResult:any) => {
					this.fetching = false;
					if(createResult.success) {
						this.setPagination(createResult.items);
					} else {
						this.globalSearchService.showNotification(createResult.message, 'danger', 'bottom', 'right');
					}
				});
			}
		}, error => {
			// If getCurrentCounts fails, try creating new sheets
			this.inventoryService.createLoadSheets(data).subscribe( (createResult:any) => {
				this.fetching = false;
				if(createResult.success) {
					this.setPagination(createResult.items);
				} else {
					this.globalSearchService.showNotification(createResult.message, 'danger', 'bottom', 'right');
				}
			});
		});
	}

	setQty(event: any, item: any) {
		const inputValue = event.target.value.trim();
		
		// If input is empty, set to null (not counted)
		// If input is "0" or "0.0", set to 0 (counted as zero)
		// Otherwise parse the number
		let val: number | null = null;
		if(inputValue === '' || inputValue === null || inputValue === undefined) {
			val = null; // Not counted
		} else {
			const parsed = parseFloat(inputValue);
			val = isNaN(parsed) ? null : parsed; // If invalid, treat as not counted
		}
		
		item.counted = val;
		// Update the item in allItems array
		const index = this.allItems.findIndex(i => i.line === item.line && i.stockid === item.stockid && i.bin === item.bin);
		if(index !== -1) {
			this.allItems[index].counted = val;
		}
		// Trigger auto-save after user stops typing
		this.autoSaveSubject.next();
	}

	private buildItemsToSave(): any[] {
		if(!this.allItems || !this.allItems.length) {
			return [];
		}

		return this.allItems.map(item => {
			// Only process items where counted was actually entered (not empty/null)
			const countedValue = item.counted;
			if (countedValue === '' || countedValue === null || countedValue === undefined) {
				return null; // Skip items that were never touched
			}
			
			const counted = (typeof countedValue === 'string' ? parseFloat(countedValue) : Number(countedValue));
			const qoh = item.qoh ? (typeof item.qoh === 'string' ? parseFloat(item.qoh) : Number(item.qoh)) : 0;

			return {
				stockid: item.stockid || item.partno,
				loccode: item.loccode || this.sheetForm?.get('location')?.value || '',
				line: item.line,
				counted: isNaN(counted) ? 0 : counted,
				bin: item.bin || '',
				qoh: isNaN(qoh) ? 0 : qoh
			};
		}).filter(item => item !== null && item.stockid && item.loccode);
	}

	// Auto-save is now handled via switchMap in ngOnInit subscription
	// This method is kept for backwards compatibility but is no longer called directly
	private autoSave() {
		// Method kept for reference but auto-save is now handled via switchMap
	}

	saveCounts() {
		if(this.savingCounts){
			this.savingCounts.unsubscribe();
		}
		
		// Use allItems for saving (contains all items, not just filtered)
		if(!this.allItems || !this.allItems.length) {
			this.globalSearchService.showNotification('No items to save', 'warning', 'bottom', 'left');
			return;
		}
		
		const itemsToSave = this.buildItemsToSave(); // Only save items with required fields
		
		this.savingCounts = this.inventoryService.saveCounts(itemsToSave).subscribe(r => {

			if(r.success) {
				this.globalSearchService.showNotification(r.msg || 'Counts saved successfully', 'success', 'bottom', 'left');
				// Reload to get updated data
				this.createLoadSheets();
			} else {
				this.globalSearchService.showNotification(r.message || 'Error saving counts', 'danger', 'bottom', 'left');
			}
			this.savingCounts = false;
		}, error => {
			this.globalSearchService.showNotification('Error saving counts', 'danger', 'bottom', 'left');
			this.savingCounts = false;
		})
	}



	identify(index, item) {
		return item.line;
	}

	// Helper method for row highlighting - properly compares numbers
	getRowClass(item: any): string {
		if(!item) {return '';}
		
		// Convert to numbers for proper comparison (0 is a valid counted value!)
		// Check if counted was actually set (not null/undefined), not just truthy
		const counted = (item.counted !== null && item.counted !== undefined) 
			? (typeof item.counted === 'string' ? parseFloat(item.counted) : Number(item.counted))
			: null;
		const qoh = item.qoh ? (typeof item.qoh === 'string' ? parseFloat(item.qoh) : Number(item.qoh)) : 0;
		
		// If counted was never set, don't highlight
		if(counted === null || isNaN(counted) || isNaN(qoh)) {return '';}
		
		// Only highlight if there's a real discrepancy (counted is entered and differs from QOH)
		// This includes when counted is 0 and qoh is not 0
		if(Math.abs(counted - qoh) > 0.001) { // Use small epsilon for float comparison
			return counted > qoh ? 'discrepancy-increase' : 'discrepancy-decrease';
		}
		
		return '';
	}

	// Get display value for counted input - properly handles 0
	getCountedDisplayValue(item: any): string {
		if(!item) {return '';}
		// Explicitly check for null/undefined, but allow 0 as a valid value
		if(item.counted === null || item.counted === undefined) {return '';}
		// Convert to string - 0 will become "0", not empty string
		return String(item.counted);
	}

	// Get input background class based on current counted vs QOH
	getInputBackgroundClass(item: any): string {
		if(!item || (item.counted === null || item.counted === undefined)) {return '';}
		
		// Convert to numbers for proper comparison (0 is a valid counted value!)
		const counted = typeof item.counted === 'string' ? parseFloat(item.counted) : Number(item.counted);
		const qoh = typeof item.qoh === 'string' ? parseFloat(item.qoh) : Number(item.qoh);
		
		// Check for NaN
		if(isNaN(counted) || isNaN(qoh)) {return '';}
		
		// If counted matches QOH, show success (green) - including when both are 0
		if(Math.abs(counted - qoh) < 0.001) {
			return 'bg-success text-white';
		}
		
		// If counted differs from QOH, show warning (yellow) or danger (red)
		// Red for decrease (including counting 0 when qoh > 0), yellow for increase
		if(counted !== qoh) {
			return counted < qoh ? 'bg-danger text-white' : 'bg-warning text-white';
		}
		
		// Fall back to server's background if no counted value
		return item.background || '';
	}

	toggleFlip() {
		// If we're returning to counting after closing and adjusting stock, clear everything
		if(this.flip == 'active' && this.reviewComponent && this.reviewComponent.count_results) {
			// User is going back to counting after closing counts - clear sheets and reset
			this.resetSheets();
			return;
		}
		
		this.flip = (this.flip =='inactive') ? 'active' : 'inactive';
		if(this.flip == 'active') {

		}
	}

	toggleFilters() {
		this.filtersExpanded = !this.filtersExpanded;
	}

	back(): void {
		this.lLoaction.back()
	}


	setPagination(tableData) {
		// Store all items for filtering
		this.allItems = tableData || [];
		this.applyFilter();
		// Auto-collapse filters when items are loaded to save screen space
		if(tableData && tableData.length > 0) {
			this.filtersExpanded = false;
		}
	}

	applyFilter() {
		// Show all items (filtering removed per user request)
		const filteredData = this.allItems;
		
		this.counting_items = new MatTableDataSource < any > (filteredData);
		this.cd.detectChanges();
		this.counting_items.paginator = this.paginator;
		this.dataObs = this.counting_items.connect();
	}

	closeCounts() {
		if(this.reviewComponent) {
			this.reviewComponent.closeCounts();
		}
	}

	resetCounts() {
		if(this.reviewComponent) {
			this.reviewComponent.clearCounts();
		}
	}

}
